export default __webpack_public_path__ + "169775f1325356ea34b5ef2a171203af.svg";